import { render, staticRenderFns } from "./TepPreliquidacionNacionalIndex.vue?vue&type=template&id=2b6e5102"
import script from "./TepPreliquidacionNacionalIndex.vue?vue&type=script&lang=js"
export * from "./TepPreliquidacionNacionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports